import type { TenantConfig } from '@/types/TenantConfig'

const grey = '#24333F'
const red = '#EE293D'

export const ticketera: TenantConfig = {
  logo: 'assets/ticketera/static/logo.png',
  themeOptions: {
    primaryColor: red,
    secondaryColor: red,
    headerBackground: red,
    footerBackgroundColor: grey,
    footerTextColor: 'white',
    logoHeight: '55px',
    cartHeaderBackgroundColor: grey,
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/ticketera/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-300px',
        mobile: '-250px',
      },
    },
  },
}
